import React from "react";
import "./NavBar.css"
import { Link } from "react-router-dom";
import logo from "./images/logo.png"

class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.dropdown = this.dropdown.bind(this)
        this.fold = this.fold.bind(this)
    }


    dropdown(event) {
        event.preventDefault()
        if(event.target.parentNode.className === "dropdown-container") {
            event.target.parentNode.children[1].style.display = "flex";
        }
    }

    fold(event) {
        event.preventDefault()
        if(event.target.parentNode.className === "dropdown-container") {
            event.target.parentNode.children[1].style.display = "none";
        } else {
            event.target.parentNode.style.display = "none";
        }
    }

    render() {
        return (
            <div className="container">
                <div className="symbols">
                    <img src={logo} alt="Kids in Seats Logo"/>
                </div>
                <div className="navigation">
                    <Link className="link" to="">Home</Link>
                    <Link className="link" to="/about">About</Link>
                    <Link className="link" to="/news">News</Link>
                    <Link className="link" to="/gallery">Gallery</Link>
                    <Link className="link" to="/supporters">Supporters</Link>
                    <Link className="link" to="/contact">Contact</Link>
                    <div className="dropdown-container" onMouseEnter={this.dropdown} onMouseLeave={this.fold}>
                        <p className="link">Recipients</p>
                        <div id="recipient-dropdown" className="dropdown">
                            <Link className="link" to="/login">Recipient Login</Link>
                            <Link className="link" to="/register">Become a Recipient</Link>
                        </div>
                    </div>
                    <Link id="donation" className="link" to="/donate">Donate Now</Link>
                </div>
            </div>
        )
    }
}

export default NavBar;